<!-- SaltUI SaltHazeStyles.kt SubBackground / Haze 2.0.1 FluentMaterials.kt,
     fixed sources in docs/third-party/ui-sources/saltui (Apache-2.0).
     Local browser compositor adaptation; no interactive or playback state. -->
<template>
  <div class="salt-material-surface" :class="{ 'material-backdrop-supported': backdropSupported }" aria-hidden="true">
    <svg class="salt-surface-filter" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
      <defs>
        <filter :id="filterId" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB">
          <feFlood class="salt-surface-color" result="color" />
          <feBlend in="color" in2="SourceGraphic" mode="color" result="colored" />
          <feFlood class="salt-surface-luminosity" result="luminosity" />
          <feBlend in="luminosity" in2="colored" mode="luminosity" />
        </filter>
      </defs>
    </svg>
    <div class="salt-surface-backdrop" :style="backdropStyle">
      <div class="salt-surface-noise" />
    </div>
  </div>
</template>
<script>
function supportsMaterialBackdrop() {
  if (typeof CSS === 'undefined' || typeof document === 'undefined' || !['backdrop-filter', '-webkit-backdrop-filter'].some(property => CSS.supports(property, 'blur(1px) url("#salt-surface-probe")'))) return false;
  // Safari/WebKit can report support for a backdrop filter that
  // contains an SVG URL and blend modes, but it does not paint that pipeline
  // reliably. Returning true here makes the consumer remove its opaque
  // fallback, so fixed popovers become transparent and the page underneath
  // shows through. Keep the stable material fallback on WebKit; ordinary
  // blur-only surfaces remain available through their own CSS paths.
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent || '';
  if (/AppleWebKit/i.test(ua) && !/Chrome\/|Chromium\/|Edg\//i.test(ua)) return false;
  return ['color', 'luminosity'].every(mode => {
    const blend = document.createElementNS('http://www.w3.org/2000/svg', 'feBlend');
    blend.setAttribute('mode', mode);
    return blend.mode?.baseVal > 0;
  });
}
export default {
  name: 'SaltMaterialSurface',
  data() { return { backdropSupported: supportsMaterialBackdrop() }; },
  computed: {
    filterId() { return 'salt-surface-filter-' + this._uid; },
    backdropStyle() { const filter = 'blur(var(--salt-sub-surface-blur,60px)) url("#' + this.filterId + '")'; return { backdropFilter: filter, WebkitBackdropFilter: filter }; },
  },
};
</script>
<style scoped>
/* The fixed consumer establishes the stacking context. Only decorative siblings
   apply filters, so fixed context menus keep their viewport coordinates. */
.salt-material-surface { position:absolute;inset:0;z-index:-1;pointer-events:none;overflow:hidden;isolation:isolate;border-radius:inherit;background:var(--salt-sub-surface-fallback,var(--salt-popup,#f9f9f9)); }
.salt-surface-filter { position:absolute;width:0;height:0;pointer-events:none; }
.salt-surface-backdrop { display:none;position:absolute;inset:0; }
.salt-surface-backdrop > div { position:absolute;inset:0; }
.material-backdrop-supported { background:transparent; }
/* Color and Luminosity operate on SourceGraphic in one backdrop image pipeline.
   CSS mix-blend children cannot consume the captured backdrop texture. */
.material-backdrop-supported > .salt-surface-backdrop { display:block; }
.salt-surface-color { flood-color:var(--salt-sub-surface-color); }
.salt-surface-luminosity { flood-color:var(--salt-sub-surface-luminosity); }
.salt-surface-noise { opacity:var(--salt-sub-surface-noise,.02);background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='128' height='128'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Cpath filter='url(%23n)' opacity='.5' d='M0 0h128v128H0z'/%3E%3C/svg%3E"); }
#app.salt-shell[data-material='none'] .salt-material-surface { background:var(--salt-sub-surface-fallback,var(--salt-popup)); }
#app.salt-shell[data-material='none'] .salt-material-surface > .salt-surface-backdrop { display:none; }
@media(prefers-reduced-transparency:reduce) {
  .salt-material-surface { background:var(--salt-sub-surface-fallback,var(--salt-popup)); }
  .salt-material-surface > .salt-surface-backdrop { display:none; }
}
</style>
